import React from 'react';

const UpdatesPage = () => {
    return (
        <>
            <div>Welcome to Gallery</div>
        </>
    );
};

export default UpdatesPage;